import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../redux/slice/userslice"; // Import logout action
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import profile_icon from "../assests/profile_icon.png";

const LayoutHeader = () => {
  const [currentTime, setCurrentTime] = useState<string>("");
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.user); // Correctly access user state
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout()); // Dispatch logout action
    navigate("/"); // Redirect to the login page after logout
  };

  // Function to update current time
  const updateTime = () => {
    const now = new Date();
    const timeString = now.toLocaleTimeString();
    setCurrentTime(timeString);
  };

  useEffect(() => {
    // Update the time every second
    const timer = setInterval(updateTime, 1000);

    // Clean up the interval on component unmount
    return () => clearInterval(timer);
  }, []);

  return (
    <header
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 20px",
        backgroundColor: "#f0f0f0", // Set a background color
      }}
    >
      <h1 style={{ margin: 0 }}>
        {user.isAuthenticated ? "Welcome" : "Please log in"}
      </h1>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Button
          style={{
            border: "2px solid #d4d4d4",
            borderRadius: "10px",
            display: "flex",
            fontFamily: "Poppins-Medium",
            fontSize: "20px",
            justifyContent: "center",
            marginRight: "10px",
            minWidth: "130px",
            padding: "4px 12px",
          }}
        >
          <span style={{ marginRight: 20 }}>{currentTime}</span>{" "}
        </Button>

        {user.isAuthenticated && (
          <Button
            onClick={handleLogout}
            style={{
              marginLeft: "20px",
              border: "2px solid #d4d4d4",
              borderRadius: "10px",
              display: "flex",
              fontFamily: "Poppins-Medium",
              fontSize: "16px",
              justifyContent: "center",
              marginRight: "10px",
              minWidth: "130px",
              padding: "4px 12px",
            }}
          >
            Logout
          </Button>
        )}
      </div>

      <img
        src={profile_icon}
        style={{ width: "40px", height: "40px" }}
        onClick={() => navigate(`/Accountant/profile`)}
      />
    </header>
  );
};

export default LayoutHeader;
